/* global femcare */

femcare.product.viewer360 = {
    mediaPanel: null,
    configPath: null,
    licensePath: null,

    init() {
        this.mediaPanel = document.querySelector('.product-main__media-panel');
        this.configPath = this.mediaPanel?.dataset['360Src'] || null;
        this.licensePath = this.mediaPanel?.dataset['360Lic'] || null;

        if (this.configPath && this.licensePath) {
            this.loadWebrotate();
        }
    },

    loadWebrotate() {
        const assetsPath = femcare.shared.util.getAssetsPath();
        const jsPath = `${assetsPath}/js/vendor/webrotate/imagerotator.js`;
        const cssPath = `${assetsPath}/css/webrotate.css`;

        try {
            femcare.loader.toggleLoader(this.mediaPanel, true);

            const linkEl = document.createElement('link');
            linkEl.rel = 'stylesheet';
            linkEl.href = cssPath;
            document.head.appendChild(linkEl);

            const scriptEl = document.createElement('script');
            scriptEl.src = jsPath;
            scriptEl.onload = () => {
                $('#product-360-player').rotator({
                    licenseFileURL: this.licensePath,
                    configFileURL: this.configPath,
                    googleEventTracking: false,
                    apiReadyCallback: () => {
                        femcare.loader.toggleLoader(this.mediaPanel, false);
                    }
                });

            };
            scriptEl.onerror = () => {
                femcare.loader.toggleLoader(this.mediaPanel, false);
            };
            document.head.appendChild(scriptEl);
        } catch (error) {
            femcare.loader.toggleLoader(this.mediaPanel, false);
        }
    }
};
